import { BUILD_VERSION } from '../../lib/build-info.js';

export interface BuildDetail {
  version: string;
  commit: string;
  builtAt: string;
}

/**
 * When this build was made, which the bundle deliberately does not carry.
 *
 * `vite.config.ts` defines the version string but leaves the timestamp out, because it
 * would change the entry chunk's content hash on every build. It writes the full record to
 * `build-info.json` beside the bundle instead, which the Worker serves straight off the
 * assets binding — `run_worker_first` does not cover it, so this costs no Worker request.
 *
 * The dev server emits no such file, so a miss is the ordinary case and not an error: the
 * screen shows the version alone. Memoized because the tab it sits on gets switched away
 * from and back.
 */
let pending: Promise<BuildDetail | null> | null = null;

export function loadBuildDetail(): Promise<BuildDetail | null> {
  pending ??= fetch('/build-info.json', { cache: 'no-store' })
    .then((response) => (response.ok ? (response.json() as Promise<BuildDetail>) : null))
    .then((detail) =>
      detail != null && typeof detail.builtAt === 'string' ? detail : null,
    )
    .catch(() => null);
  return pending;
}

/** What "Copy version info" puts on the clipboard: everything a support reply needs. */
export function versionReport(detail: BuildDetail | null): string {
  const lines = [`Platewell ${BUILD_VERSION}`];
  if (detail != null) {
    lines.push(`commit ${detail.commit}`, `built ${detail.builtAt}`);
  }
  lines.push(navigator.userAgent);
  return lines.join('\n');
}
